import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ToastKind = 'info' | 'success' | 'warning' | 'error'

export interface Toast {
  id: number
  kind: ToastKind
  text: string
  description: string | null
  timeout: number
}

export const useToastStore = defineStore('toast', () => {
  const list = ref<Toast[]>([])
  let nextId = 1

  function add(
    text: string,
    kind: ToastKind = 'info',
    description: string | null = null,
    timeout = 3000,
  ) {
    const id = nextId++
    const toast: Toast = { id, kind, text, timeout, description }
    list.value.push(toast)
    setTimeout(() => remove(id), timeout)
  }

  function remove(id: number) {
    const idx = list.value.findIndex((t) => t.id === id)
    if (idx >= 0) list.value.splice(idx, 1)
  }

  return { list, add, remove }
})
